let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => {
      // One faulty subscriber must not take down the others, nor the code that
      // runs after publish(). That is exactly how a missing element on the
      // product page stopped the header cart count from updating.
      try {
        return Promise.resolve(callback(data));
      } catch (error) {
        console.error(`[pubsub] subscriber for "${eventName}" failed`, error);
        return Promise.resolve();
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}
